module.exports = __webpack_public_path__ + "img/minus.7eecb4f9.svg";